var map = {
	"./audio-placeholder": 433,
	"./audio-placeholder.png": 433,
	"./avatar-missing": 350,
	"./avatar-missing.png": 350,
	"./avatar-missing.svg": 1083,
	"./header-missing": 352,
	"./header-missing.png": 352,
	"./soapbox-logo": 353,
	"./soapbox-logo-white": 354,
	"./soapbox-logo-white.svg": 354,
	"./soapbox-logo.svg": 353,
	"./video-placeholder": 434,
	"./video-placeholder.png": 434,
	"./void": 435,
	"./void.png": 435,
	"./web-push/web-push-icon_expand": 478,
	"./web-push/web-push-icon_expand.png": 478,
	"./web-push/web-push-icon_favourite": 479,
	"./web-push/web-push-icon_favourite.png": 479,
	"./web-push/web-push-icon_reblog": 480,
	"./web-push/web-push-icon_reblog.png": 480
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1082;